import assetScope from './module/assetScope';
import accountCenter from './module/accountCenter';
import advert from './module/advert';
import agreement from './module/agreement';
import brand from './module/brand';
import decorateGlobal from './module/decorateGlobal';
import general from './module/general';
import material from './module/material';
import menu from './module/menu';
import print from './module/print';
import product from './module/product';
import deviceAuthorization from './module/deviceAuthorization';
import cashRegister from './module/cashRegister';
import commz from './module/commz';
import integration from './module/integration';
import groupBuy from './module/groupBuy';
import member from './module/member';
import chargeScene from './module/chargeScene';
import operateSettlement from './module/operateSettlement';
import operateReport from './module/operateReport';
export default {
  ...general, // 通用
  ...assetScope,
  ...accountCenter, // 账号中心
  ...advert, // 广告管理
  ...agreement, // 用户协议
  material, // 素材
  menu, // 菜单
  ...brand,
  ...product,
  decorate: { ...brand.decorate, ...decorateGlobal.decorateGlobal }, // 装修及全局配置
  ...print,
  ...deviceAuthorization,
  ...cashRegister,
  ...commz,
  ...integration, // 第三方平台授权
  ...groupBuy,
  ...chargeScene,
  member,
  ...operateSettlement,
  ...operateReport,
};
